import React, { useState, useRef } from "react";
import DayPicker from "react-day-picker";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { format } from 'date-fns';
import { addMonths, startOfMonth } from 'date-fns';
import {
  Container,
  DropdownContainer,
  DateAvailableIcon,
  DateDescription,
  OpenDate,
  LabelContainer,
  LabelItem,
} from "./styles";
import useOutsideClickDropdown from "~/hooks/useOutsideClickDropdown";
import "react-day-picker/lib/style.css";

export default function NewDatePicker({ loadingConfirm }) {
  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ];
  const WEEKDAYS_SHORT = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");

  const logisticReducer = useSelector((state) => state.logisticReducer);

  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  useOutsideClickDropdown(dropdownRef, setShowDropdown);

  const handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }
    setShowDropdown();
    const formatDay = format(day, 'dd/MM/yyyy');
    dispatch({ type: "ADD_DATE", date: formatDay });
    setSelectedDay(day);
  };

  const today = new Date();
  today.setDate(today.getDate() + 1);
  
  const maximumDate = new Date(today);
  maximumDate.setDate(today.getDate() + 7);

  const firstDayOfNextMonth = startOfMonth(addMonths(today, 0));
  
  return (
    <>
      <Dropdown show={showDropdown} ref={dropdownRef} id="datepicker"  style={{ textAlign: 'right', width: '100%' }}>
        <DropdownContainer
          as={Dropdown.Toggle}
          disabled={loadingConfirm}
          onClick={() => {
            setShowDropdown(!showDropdown);
          }}
          id='date-order'
          className="width-date-inout-order"
          style={{
            backgroundColor: "#ffffff",
            boxShadow: "0px 2px 2px #00000029",
            border: "1px solid rgba(80, 80, 80, 0.3)",
            color: "#808080",
            fontSize: "0.7rem",
            textAlign: "left",
            AlignItems: "center",
            fontFamily: "Roboto",
            margin: 0,
            width: "100% !important"
          }}
        >

        {logisticReducer.date !== "" ? logisticReducer.date : "DD/MM/AAAA"}
   
        </DropdownContainer>
        <Container as={Dropdown.Menu}>
          <DayPicker
            initialMonth={firstDayOfNextMonth}
            toMonth={maximumDate}
            disabledDays={{ before: today, after: maximumDate }}
            onDayClick={handleDayClick}
            months={MONTHS}
            weekdaysLong={WEEKDAYS_LONG}
            weekdaysShort={WEEKDAYS_SHORT}
            selectedDays={selectedDay}
            enableOutsideDaysClick={true}
          />
          <LabelContainer>
            <LabelItem>
              <DateAvailableIcon className="fa fa-fw fa-circle" />
              <DateDescription> Datas indisponíveis</DateDescription>
            </LabelItem>
            <LabelItem>
              <OpenDate className="fa fa-fw fa-circle"></OpenDate>
              <DateDescription> Datas em aberto</DateDescription>
            </LabelItem>
          </LabelContainer>
        </Container>
      </Dropdown>
    </>
  );
}
